import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MyContext } from "./MyContext";
import Auth from "./Auth";

export const FARM_BILLING_CHECK_INTERVAL = 24 * 60 * 60 * 1000;
export const FARM_BILLING_STATUS_ENDPOINT = null;

export default function FarmBillingWarning() {
  const { mystate } = useContext(MyContext);
  const [billingStatus, setBillingStatus] = useState(null);
  const isAdmin = Auth.getUserType() === "ADM";

  useEffect(() => {
    if (!isAdmin || !FARM_BILLING_STATUS_ENDPOINT) return;
    let cancelled = false;
    let pending = false;
    let lastSuccessfulCheck = 0;

    const checkBilling = async () => {
      if (
        pending ||
        document.visibilityState === "hidden" ||
        Date.now() - lastSuccessfulCheck < FARM_BILLING_CHECK_INTERVAL
      ) return;
      pending = true;
      try {
        const result = await Auth.api(FARM_BILLING_STATUS_ENDPOINT, "get", {});
        if (typeof result?.data?.billing_attention_required !== "boolean") return;
        if (!cancelled) {
          setBillingStatus(result.data);
          lastSuccessfulCheck = Date.now();
        }
      } catch {
      } finally {
        pending = false;
      }
    };

    checkBilling();
    document.addEventListener("visibilitychange", checkBilling);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", checkBilling);
    };
  }, [isAdmin, mystate.farmDefaults]);

  const needsAttention =
    billingStatus?.billing_attention_required ??
    mystate.farmDefaults.billing_attention_required;
  if (!isAdmin || needsAttention !== true) return null;

  return (
    <div
      role="alert"
      style={{
        flex: "1 1 100%",
        boxSizing: "border-box",
        padding: "10px 12px",
        marginBottom: 12,
        borderLeft: "4px solid #b42318",
        background: "#fff1f0",
        color: "#852016",
      }}
    >
      Your Equine Office account needs billing attention.{" "}
      <Link to="/admin/setup/preferences#plan-status">View Plan Status</Link>
    </div>
  );
}